module.exports = __webpack_public_path__ + "img/Pot2.bb48665c.svg";